import React, { useEffect } from "react";
import Hero from "../components/hero/Hero";
import About from "../components/about/About";
import Menus from "../components/menus/Menus";
import OpeningHours from "../components/openinghours/OpeningHours";
import ContactForm from "../components/contactform/ContactForm";
import Map from "../components/map/map";
import Photos from "../components/photos/photos";

import { useLocation } from "react-router-dom";

const Home = () => {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.replace("#", ""));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [hash]);

    return (
        <div>
            <Hero />
            <About />
            <Photos />
            <Menus />
            <OpeningHours />
            <ContactForm />
            <Map />
        </div>
    );
};

export default Home;
